import { useQuery } from '@northladder/services';

import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

const FETCH_PASSWORD_POLICY = 'fetch-password-policy-query-key';

/**
 * Custom hook to fetch the password policy list.
 */
export const usePasswordPolicyListQuery = () => {
  const { data, error, isPending } = useQuery({
    queryKey: [FETCH_PASSWORD_POLICY],
    queryFn: () => USER_ACCOUNTS_API.fetchPasswordPolicyList(),
    networkMode: 'always',
    retry: false,
  });

  return {
    passwordPolicyList: data,
    error,
    isPending,
  };
};
